export const host = 'https://sushibox.one';
export const baseUrl = '/api';

export const restUrls = {
  singIn: '/auth/local',
  currentUser: '/users/me',
  userOrders: '/user/orders',
  userArchive: '/user/archive',
  users: '/users',
  register: '/auth/local/register',
  cities: '/cities_fields',
  filials: '/points',
  zone: '/zones',
  orders: '/orders',
  archive: '/archive',
  settings: '/settings',
  promocodes: '/promocodes',
  cashback: '/cashback',
  chanels: '/chanels',
  messages: '/messages',
  ratings: '/ratings',
  counter: '/counter',
  statistics: '/statistics',
  phonecodes: '/phonecodes',
  authComposer: '/phonecodes/composer',
  generateAuthPhone: '/phonecodes/waitcall/get-number',
  authWaitCall: '/phonecodes/waitcall/confirmed',
  news: '/news',
  goods: '/goods',
  categories: '/categories',
  sendMail: '/mail/send',
  sliders: '/sliders',
  promotions: '/promotions',
  usersaddresses: '/usersaddresses',
};
